import './index.scss';

import { Component } from 'react';

import t from 'utils/i18n';
import { BraxIcon } from '../BraxIcon';

export type BraxStatusProps = {
    lastUpdate: Date,
    state: 'success' | 'failure'
};

export class BraxStatus extends Component<BraxStatusProps> {

    messages: { [K in BraxStatusProps['state']]: string } = {
        success: 'Todas as alterações salvas com sucesso',
        failure: 'Houve um problema na sincronização'
    };

    dateTimeFormat = new Intl.DateTimeFormat([], {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: undefined
    });

    render() {
        return (
            <div className={`brax-status ${this.props.state}`}>
                <div>
                    <BraxIcon icon={`sync-${this.props.state}`} />
                </div>

                <p className="hint">
                    { t(this.messages[this.props.state]) }
                </p>

                <p className="hint">{ t('Último salvamento: %d', this.dateTimeFormat.format(this.props.lastUpdate)) }</p>
            </div>
        );
    }

}
